const getNotifState = state => state.notification;

const notifSelectors = {getNotifState};

export default notifSelectors;